// Get all reports
export const getFnbReports = async (_, apiService) => {
  try {
    const { user } = apiService.extra.apiService;
    const response = await user.get("/fnbreports");
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

// Create new report
export const createFnbReport = async (data, apiService) => {
  try {
    const { user } = apiService.extra.apiService;
    const response = await user.post("/fnbreports", data);
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

// Update existing report
export const updateFnbReport = async (data, apiService) => {
  try {
    const { user } = apiService.extra.apiService;
    const { id, name, terminal, store, breakup } = data;
    const response = await user.put(`/fnbreports/${id}`, {
      name,
      terminal,
      store,
      breakup,
    });
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

// Delete report
export const deleteFnbReport = async (id, apiService) => {
  try {
    const { user } = apiService.extra.apiService;
    const response = await user.delete(`/fnbreports/${id}`);
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
